<template>
  <div class="payment-result failed">
    <div class="container text-center py-5">
      <h2 class="text-danger">❌ Paiement échoué</h2>
      <p>Votre paiement n’a pas pu être validé. Merci de réessayer.</p>
      <button class="btn btn-orange mt-3" @click="retryPayment">
        Réessayer le paiement
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentFailed",
  props: ["orderToken"],
  methods: {
    retryPayment() {
      this.$router.push({ name: "mode-paiement" });
    },
  },
};
</script>

<style scoped>
.text-danger {
  color: #dc3545;
}
.btn-orange {
  background-color: #ec621a;
  color: white;
  border-radius: 76px;
  font-size: 18px;
  font-weight: bold;
  padding: 10px 20px;
}
</style>
